import React from "react";
import { Box } from "@mui/material";
import useIsMobile from "../hooks/useIsMobile";

/**
 * Envolve uma imagem para que ela se adapte automaticamente ao mobile.
 * No mobile: objectFit contain, maxWidth 100%, altura fluida para não cortar arte em IA.
 * No desktop: mantém proporções e pode usar cover/contain conforme prop.
 */
export default function ResponsiveImage({
    src,
    alt = "",
    component = "img",
    desktopObjectFit = "cover",
    mobileObjectFit = "contain",
    sx = {},
    ...rest
}) {
    const isMobile = useIsMobile();

    return (
        <Box
            component={component}
            src={src}
            alt={alt}
            loading="lazy"
            sx={{
                width: "100%",
                height: "100%",
                maxWidth: "100%",
                objectFit: isMobile ? mobileObjectFit : desktopObjectFit,
                objectPosition: "center",
                ...sx,
            }}
            {...rest}
        />
    );
}
